module.exports = __webpack_public_path__ + "static/media/expert4.f614b14e.png";